import React from 'react';
import Toast from 'components/Toast';
import PropTypes from 'prop-types';
import SupportButton from 'components/SupportButton';

const toastHandlerDefaultPropOnCloseHandler = () => {};
const ToastHandler = ({
  toastType = /** @type {string|null} */ (null),
  showToast = false,
  onCloseHandler = toastHandlerDefaultPropOnCloseHandler,
  title = '',
  description = '',
  duration = 5000
}) => {
  return (
    <Toast
      type={toastType}
      isBold
      open={showToast}
      title={title}
      onClose={onCloseHandler}
      timeout={duration}
    >
      {toastType === 'warning' && !!description && <div>{description}</div>}
      {toastType === 'error' && (
        <>
          {!!description && <div>{description}</div>}
          <SupportButton />
        </>
      )}
    </Toast>
  );
};

ToastHandler.propTypes = {
  toastType: PropTypes.string,
  showToast: PropTypes.bool,
  onCloseHandler: PropTypes.func,
  title: PropTypes.string,
  description: PropTypes.string,
  duration: PropTypes.number
};

export default ToastHandler;
